export class ValidationUtil {
    
    static validation(obj) {
        let value = obj.value;
        //console.log(obj);
        
        if (obj.type == 'checkbox' || obj.type == 'radio') {
            obj.result = true;
            obj.error = '';
            return obj;
        }
        
        const trimmedValue = value !== undefined ? value.trim() : '';
        //obj.value = this.escapeHtml(value);
        
        // Empty
        if (!trimmedValue && obj.required) {
            //console.log(trimmedValue);
            obj.result = false;
            obj.error = 'empty';
            return obj;
        }
        
        // 追加の条件：obj.maxが設定されている場合、文字数がそれを超えているかどうかを判定
        if (obj.max !== undefined && trimmedValue.length > obj.max) {
            obj.result = false;
            obj.error = 'max';
            return obj;
        }
        
        // Email
        if (obj.type === 'email') {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailRegex.test(value)) {
                console.log(value);
                obj.result = false;
                obj.error = 'email';
                return obj;
            }
        } else if (obj.type === 'number') {
            // 数字以外があった場合エラー
            const numberRegex = /^[0-9-]+$/;
            if (!numberRegex.test(value)) {
                console.log(value);
                obj.result = false;
                obj.error = 'number';
                return obj;
            }
        } else if (obj.type === 'tel') {
            // 数字かハイフン以外があった場合エラー
            const numberRegex = /^[0-9\-+]+$/;
            if (!numberRegex.test(value)) {
                console.log(value);
                obj.result = false;
                obj.error = 'tel';
                return obj;
            }
        } 

        obj.result = true;
        obj.error = '';
        return obj;
    }

    static containsScript(text) {
        const scriptPattern = /<script.*?>|<\/script>/i;
        return scriptPattern.test(text);
    }

    static escapeHtml(text) {
        // エスケープ処理
        const escapeChars = {
            '&': '&amp;',
            '<': '&lt;',
            '>': '&gt;',
            '"': '&quot;',
            "'": '&#x27;',
            '/': '&#x2F;'
        };

        return text.replace(/[&<>"'/]/g, char => escapeChars[char]);
    }
}